export enum ErrorDataProps {
  SummaryErrors = 'summaryErrors',
  InvalidParams = 'invalidParams',
  Code = 'code',
}
